import { render, staticRenderFns } from "./shipmentDetail copy.vue?vue&type=template&id=283ab1ca&scoped=true"
import script from "./shipmentDetail copy.vue?vue&type=script&lang=js"
export * from "./shipmentDetail copy.vue?vue&type=script&lang=js"
import style0 from "./shipmentDetail copy.vue?vue&type=style&index=0&id=283ab1ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ab1ca",
  null
  
)

export default component.exports